import { validate as validatePhone } from './validators/phone'
import {
  FORM_LOGIN,
  FORM_PASSWORD_RECOVERY,
  FORM_SMS,
  FORM_SIGNUP,
} from '../shared/formStates'

export const EMAIL_REGEXP = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
export const PHONE_REGEXP = /^[0-9]{5,}/

const validateSignUp = ({
                          name,
                          password,
                          email,
                          privacyPolicy,
                          privacyPolicy2,
                          phone,
                          country,
                          state,
                          dynamicValidation,
                          ...rest
                        }) => {
  const errors = []
  if(dynamicValidation){
    const arr = dynamicValidation.split('#$#')
    arr.forEach(item =>{
      if(!rest?.[item]?.[0]){
        errors.push(item)
      }
    })
  }
  if (!name) errors.push('name')
  if (!password) errors.push('password')
  if (!email) errors.push('email')
  if (!privacyPolicy) errors.push('privacyPolicy')
  if (!privacyPolicy2) errors.push('privacyPolicy2')
  if (!country) errors.push('country')
  if (!state && (country === 'United States' || country === 'Canada')) errors.push('state')
  if (password.length < 6) errors.push('password.tooshort')
  if (!EMAIL_REGEXP.test(email)) {
    errors.push('email.notvalid')
  }
  if (!validatePhone(phone)) {
    errors.push('phone.notvalid')
  }
  return errors
}

const validateEmail = ({ email }) => {
  const errors = []
  if (!email) errors.push('name')
  if (!EMAIL_REGEXP.test(email)) {
    errors.push('email.notvalid')
  }

  return errors
}

const validateLogin = ({ email, password }) => {
  const errors = validateEmail({ email })

  if (!password) errors.push('password')

  return errors
}

const validateSMS = () => {
  return []
}

export const validateLargeForm = (formState, state) => {
  if (formState === FORM_SIGNUP) return validateSignUp(state)
  if (formState === FORM_LOGIN) return validateLogin(state)
  if (formState === FORM_SMS) return validateSMS(state)
  if (formState === FORM_PASSWORD_RECOVERY) return validateEmail(state)
}
